// extracted by mini-css-extract-plugin
export default {"cellWrapper":"Theme29Task2_cellWrapper__OxwMD","cell":"Theme29Task2_cell__DWKLT"};